<template>
  <div class="grid grid-cols-1-auto gap-4">
    <input-text
      :value="formData.text"
      @enter-key="touched ? submit(formOptions) : false"
      label="Option"
      @update-value="updateText($event)"
    />
    <div class="self-end mb-2 text-lg">
      <wd-button transparent @input="unsaved ? emitRemove() : deleteOption()">
        <span>
          <icon name="Trash" />
        </span>
      </wd-button>
      <wd-button transparent @input="submit(formOptions)" v-if="touched">
        <span class="ml-3">
          <icon name="Accept" />
        </span>
      </wd-button>
    </div>
  </div>
</template>

<script>
import { SurveyOption } from "@/modules/surveys/viewmodels/SurveyOption";
import FormMixin from "@/mixins/FormMixin";

export default {
  name: "SurveyOption",
  mixins: [FormMixin],
  data() {
    return {
      touched: false,
    };
  },
  props: {
    option: {
      type: SurveyOption,
      required: true,
    },
    surveyId: {
      type: String,
    },
    unsaved: {
      default: false,
      type: Boolean,
    },
  },
  components: {},
  methods: {
    updateText(Input) {
      this.updateForm("text", Input);
      this.touched = true;
    },
    emitRemove() {
      this.$emit("remove");
    },
    deleteOption() {
      let translation = this.$t("surveys.manage.survey_option_deleted");
      let deleteFormOptions = {
        async: true,
        type: "surveyoption",
        call: "destroy",
        sendingVar: false,
        id: this.option.id,
        action: (response) => {
          this.deleteSending = false;
          this.popup({
            title: translation,
          });
        },
      };

      this.submit(deleteFormOptions);
    },
  },
  computed: {},
  created() {
    if (this.unsaved) {
      this.formData.survey_id = this.surveyId;
    } else {
      this.formData = this.option;
    }

    if (this.unsaved) {
      this.formOptions = {
        async: true,
        type: "surveyoption",
        call: "create",
        action: (response) => {
          this.emitRemove();
          this.touched = false;
          this.popup({
            title: this.$t("surveys.manage.survey_option_created"),
            autohide: true,
          });
        },
      };
    } else {
      this.formOptions = {
        async: true,
        type: "surveyoption",
        call: "update",
        id: this.option.id,
        action: (response) => {
          this.touched = false;
          this.popup({
            title: this.$t("surveys.manage.survey_option_updated"),
            autohide: true,
          });
        },
      };
    }
  },
};
</script>
